import { render, staticRenderFns } from "./bromierung-benzol.vue?vue&type=template&id=41a078e6&"
import script from "./bromierung-benzol.vue?vue&type=script&lang=js&"
export * from "./bromierung-benzol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports